export default __webpack_public_path__ + "static/background-ae1afd5d7b8687c3c4bc164a9b07abd9.webp";